import palette from '../../theme/palette';

export const theme = {
  slatePaneHeader: {
    background: palette.sidebarBg,
    color: palette.white,
    borderBottom: `1px solid ${palette.sidebarBorder}`,
  },
};
